import { Component, AfterViewInit, OnDestroy, Input, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { HelperService } from "@mypxplat/xplat/core";
import type Quill from "quill";

let nextId = 0;

// When rendering saved content from this editor, wrap it in a div with class="quill-content" for proper styling.
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "fui-quill-editor",
  templateUrl: "fui-quill-editor.component.html",
  standalone: false,
})
export class FuiQuillEditorComponent implements AfterViewInit, OnDestroy {
  @Input() content: string = "";
  @Input() placeholder: string = "Write something...";
  @Input() height: string = "150px";
  @Input() toolbarOptions: any[] = [["bold", "italic", "underline", "strike"], [{ header: [1, 2, 3, false] }], [{ list: "ordered" }, { list: "bullet" }], ["link"], ["clean"]];
  @Output() contentChange: EventEmitter<string> = new EventEmitter();

  @ViewChild("editor", { static: true }) editorRef: ElementRef;
  @ViewChild("toolbar", { static: true }) toolbarRef: ElementRef;

  public editorId: string;
  private quill: Quill;
  private destroyed = false;

  constructor(private helperService: HelperService) {
    this.editorId = `fui-quill-${nextId++}`;
  }

  ngAfterViewInit() {
    setTimeout(() => this.initQuill(), 100);
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.quill = null;
  }

  private async initQuill() {
    // Quill is loaded on demand so it stays out of the main bundle.
    const { default: Quill } = await import("quill");
    if (this.destroyed) return;
    this.quill = new Quill(this.editorRef.nativeElement, {
      modules: { toolbar: this.toolbarOptions },
      placeholder: this.placeholder,
      theme: "snow",
    });

    if (this.content) {
      this.quill.clipboard.dangerouslyPasteHTML(this.content);
    }

    const toolbar = (this.quill.getModule("toolbar") as any).container;
    this.toolbarRef.nativeElement.appendChild(toolbar);

    this.quill.on("text-change", () => {
      const html = this.helperService.sanitizeQuillHtml(this.quill.root.innerHTML);
      this.contentChange.emit(html);
    });
  }
}
